import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Row,
  Form,
  Modal,
  ButtonGroup,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchInvoice,
  selectDataMaterial,
  fetchMaterial,
  selectBlock,
} from "./withoutRtvSlice";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useHistory } from "react-router-dom";

import {
  showErrorDialog,
  sizePerPageList,
  showDialog,
  showConfirmDialog,
  showSuccessDialog,
} from "../../../../utility";
import { WithoutRtvTable } from "./WithoutRtvTable";
import { selectUser } from "../../../../modules/Auth/_redux/authRedux";
import { fetchCustomer, selectDataCustomer } from "../../with-rtv/withrtvSlice";
import {
  postSynchNrablank,
  postSynchNracustx,
  postSynchNrax,
  postSynchNracustblank,
  postSynchMaterial,
  postSynchCrprgp,
  postSynchBatch,
  postSynchCustomer,
  postSynchMaterialExt,
} from "../../../administrator/general-setting/generalSettingSlice";
import LoadingFetchData from "../../../../utility/LoadingFetchData";
import MultiSelectAll from "../../../../utility/MultiSelectAll";

export const WithoutRtvPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const user = useSelector(selectUser);
  const dataCustomer = useSelector(selectDataCustomer);
  const dataMaterial = useSelector(selectDataMaterial);
  const history = useHistory();

  const defaultPlant = user.plants.map((e) => {
    return e.plantCode.toString();
  });
  const defaultPlantName = user.plants.map((e) => {
    return e.plantName.toString();
  });

  // Filter
  const [invoiceNo, setInvoiceNo] = useState("");
  const [batch, setBatch] = useState("");
  const [overlay, setOverlay] = useState(false);
  const [overlayCustomer, setOverlayCustomer] = useState(false);
  const [plantCode, setPlantCode] = useState([]);

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    setPlantCode(defaultPlant);
  }, []);

  const handleSearch = async () => {
    if (invoiceNo === "") {
      return showDialog("Please Fill Out Invoice Ref Number Field");
    }
    if (plantCode.length < 1) {
      return showErrorDialog("Please select plant");
    }
    setOverlay(true);
    const params = {
      invoiceNo: invoiceNo.replace(/\s/g, ""),
      plantCode: plantCode.toString(),
      customerCode: selectCustomer.customerCode,
      customerName: selectCustomer.customerName,
      batch: batch,
      materialCode: selectMaterial.materialCode,
      materialDescription: selectMaterial.materialDescription,
      pageNo: 1,
      pageSize: 10,
    };
    console.log(params, "params");
    try {
      const response = await dispatch(fetchInvoice(params));
      if (response.payload.status === 200) {
        setOverlay(false);
        if (response.payload.data.length < 1) {
          const action = await showConfirmDialog(
            `Invoice Reff does not exist or has Non-TF status or not relevant in your branch. Do you want to create Non-reference Return?`
          );
          if (action.isConfirmed);
          history.push("/new-return/non-rtv/non-reference", {
            invoice: invoiceNo,
          });
        }
      } else {
        setOverlay(false);
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      setOverlay(false);

      console.log(error);
      showErrorDialog("eror something wrong");
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        invoiceNo: invoiceNo.replace(/\s/g, ""),
        plantCode: plantCode.toString(),
        customerCode: selectCustomer.customerCode,
        customerName: selectCustomer.customerName,
        batch: batch,
        materialCode: selectMaterial.materialCode,
        materialDescription: selectMaterial.materialDescription,
        pageNo: page,
        pageSize: sizePerPage,
      };
      setOverlay(true);
      try {
        const response = await dispatch(fetchInvoice(params));
        if (response.payload.status === 200) {
          setOverlay(false);
          if (response.payload.data.length < 1) {
            const action = await showDialog(
              `Invoice Reff does not exist or has Non-TF status or not relevant in your branch. Do you want to create Non-reference Return?`
            );
            if (action.isConfirmed);
            history.push("/new-return/non-rtv/non-reference", {
              invoice: invoiceNo,
            });
          }
        } else {
          setOverlay(false);
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        setOverlay(false);

        console.log(error);
        showErrorDialog("eror something wrong");
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
        console.log(result, "asc");
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // Modal Material
  const [show, setShow] = useState(false);
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [selectCustomer, setSelectCustomer] = useState([]);

  const handleClose = () => {
    setCustomerCode("");
    setCustomerName("");
    setShow(false);
    setTableDataCustomer([]);
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const [tableDataCustomer, setTableDataCustomer] = useState(dataCustomer);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = dataCustomer.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableDataCustomer(initData);
  }, [dataCustomer, pageSize, pageNo]);

  const handleSearchCustomer = async () => {
    setOverlayCustomer(true);
    const params = {
      customerCode: customerCode,
      customerName: customerName,
      plant: defaultPlant.toString(),
      pageNo: 1,
      pageSize: 100,
    };
    await dispatch(fetchCustomer(params));
    setOverlayCustomer(false);
  };

  const rowEventsCustomer = {
    onClick: (e, row, rowIndex, cell) => {
      if (row.customerBlocked === true) {
        showDialog(row.blockRemark);
      } else {
        setSelectCustomer(row);
        setCustomerCode("");
        setCustomerName("");
        setShow(false);
        setTableDataCustomer([]);
        setShow(false);
      }
    },
  };

  const columnsCustomer = [
    { text: "No", dataField: "no" },
    { text: "Sales Office", dataField: "salesOffice" },
    { text: "Customer Code", dataField: "customerCode" },
    { text: "Customer Name", dataField: "customerName" },
    { text: "distribution Channel", dataField: "distChannel" },
    { text: "Address", dataField: "street1" },
    { text: "City", dataField: "city" },
  ];

  // Modal Material
  const [showMaterial, setShowMaterial] = useState(false);
  const [materialCode, setMaterialCode] = useState("");
  const [materialName, setMaterialName] = useState("");
  const [selectMaterial, setSelectMaterial] = useState([]);
  const [overlayStateMaterial, setOverlayStateMaterial] = useState(false);

  const handleCloseMaterial = () => {
    setMaterialCode("");
    setMaterialName("");
    setTableDataMaterial([]);
    setShowMaterial(false);
  };
  const handleShowMaterial = () => setShowMaterial(true);

  const [showResultsMaterial, setShowResultsMaterial] = useState(false);

  const [tableDataMaterial, setTableDataMaterial] = useState(dataMaterial);

  useEffect(() => {
    // Add number
    const initData = dataMaterial.map((item, index) => {
      return {
        ...item,
        no: index + 1,
      };
    });
    setTableDataMaterial(initData);
  }, [dataMaterial]);

  const handleSearchMaterial = async () => {
    setOverlayStateMaterial(true);
    const params = {
      materialCode: materialCode,
      materialName: materialName,
      pageNo: 1,
      pageSize: 100,
    };
    await dispatch(fetchMaterial(params));
    setOverlayStateMaterial(false);
  };

  const rowEventsMaterial = {
    onClick: (e, row, rowIndex, cell) => {
      setSelectMaterial(row);
      setMaterialCode("");
      setMaterialName("");
      setTableDataMaterial([]);
      setShowMaterial(false);
    },
  };

  const columnsMaterial = [
    { text: "Material Code", dataField: "materialCode" },
    { text: "Material Desc", dataField: "materialDescription" },
    { text: "distribution Channel", dataField: "distributionChannel" },
    { text: "Uom", dataField: "baseUOM" },
  ];

  // sync customer
  const [showCustomer, setShowCustomer] = useState(false);
  const [customerCodeSynch, setCustomerCodeSynch] = useState("");
  const [customerNameSynch, setCustomerNameSynch] = useState("");
  const handleCloseCustomer = () => setShowCustomer(false);
  const handleShowCustomer = () => setShowCustomer(true);

  const handleSynchCustomer = async () => {
    // customer code
    const params = {
      P_CustomerCode: customerCodeSynch,
      P_CustomerName: customerNameSynch,
    };

    try {
      const response = await dispatch(postSynchCustomer(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        if (action.isConfirmed) await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // synch CRP RGP

  const handleSynchCrprpg = async () => {
    const params = {};
    try {
      const response = await dispatch(postSynchCrprgp(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed) await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // synch material
  const [materialSynch, setMaterialSynch] = useState("");
  const [distChannelSynch, setDistChannelSynch] = useState("");

  const [showMaterialSynch, setShowMaterialSynch] = useState(false);
  const handleCloseMaterialSynch = () => setShowMaterialSynch(false);
  const handleShowMaterialSynch = () => setShowMaterialSynch(true);

  const handleSynchMaterial = async () => {
    if (materialSynch === "") {
      return showDialog("Please Fill Out Material Field");
    }
    const params = {
      P_material: materialSynch,
      P_DistChannel: distChannelSynch,
    };
    try {
      const response = await dispatch(postSynchMaterial(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        if (action.isConfirmed) await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // synch material ext

  const [showMaterialExt, setShowMaterialExt] = useState(false);
  const handleCloseMaterialExt = () => setShowMaterialExt(false);
  const handleShowMaterialExt = () => setShowMaterialExt(true);

  const [tableName, setTableName] = useState("");
  const [ic4, setIc4] = useState("");
  const [docCat, setDocCat] = useState("");
  const [cg1, setCg1] = useState("");
  const [plant, setPlant] = useState("");
  const [salesOrg, setSalesOrg] = useState("");

  const handleSynchMaterialExt = async () => {
    if (materialSynch === "") {
      return showDialog("Please Fill Out Material Field");
    }
    // if (salesOrg === "") {
    //   return showDialog("Please Fill Out sales Org Field");
    // }
    const params = {
      tableName: tableName,
      P_SalesOrg: salesOrg,
      P_Material: materialSynch,
      P_Customer: customerCodeSynch,
      P_Batch: batch,
      P_Plant: plant,
      P_IC4: ic4,
      P_DocCat: docCat,
      P_CG1: cg1,
    };
    try {
      const response = await dispatch(postSynchMaterialExt(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        if (action.isConfirmed) await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handlePlantsChange = (selectedOptions) => {
    if (selectedOptions) {
      setPlantCode(
        selectedOptions.map(function(selectedOptions) {
          if (selectedOptions) {
            return selectedOptions["value"];
          }
        })
      );
    } else {
      setPlantCode([]);
    }
  };

  const plantOptions = user.plants.map((val) => {
    return {
      value: val.plantCode,
      label: val.plantName,
    };
  });

  function getValuePlant(plant) {
    let output = [];
    plant.map((val) => {
      const result = plantOptions.filter((plant) => val == plant.value);
      output.push(result[0]);
    });
    return output;
  }

  return (
    <>
      <Card>
        <CardHeader title="Without RTV">
          <CardHeaderToolbar>
            <ButtonGroup>
              <DropdownButton
                as={ButtonGroup}
                title="Synch"
                id="bg-nested-dropdown"
              >
                <Dropdown.Item eventKey="1" onClick={handleSynchCrprpg}>
                  Crp Rgp
                </Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={handleShowCustomer}>
                  Customer
                </Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={handleShowMaterialSynch}>
                  Material
                </Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={handleShowMaterialExt}>
                  Material Exc
                </Dropdown.Item>
              </DropdownButton>
            </ButtonGroup>
          </CardHeaderToolbar>
        </CardHeader>
        <LoadingFetchData active={overlay} />
        <CardBody>
          {/* Filter */}
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row} controlId="invoiceNo">
                  <Form.Label column sm={4}>
                    <b>
                      {" "}
                      Invoice Ref Number <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      placeholder="Invoice Ref Number"
                      onChange={(e) => {
                        setInvoiceNo(e.target.value);
                      }}
                      value={invoiceNo}
                      onKeyPress={handleKeyPress}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Sales Office</b>
                  </Form.Label>
                  <Col sm={5}>
                    <MultiSelectAll
                      options={plantOptions}
                      value={getValuePlant(plantCode)}
                      onChange={handlePlantsChange}
                      placeholder="Select Plant..."
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Code</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={selectCustomer.customerCode}
                    />
                  </Col>
                  <Col sm={1}>
                    <Button variant="light" onClick={handleShow}>
                      <i className="fa fa-search"></i>
                    </Button>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Code</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={selectCustomer.customerName}
                    />
                  </Col>
                </Form.Group>
              </Col>

              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Batch</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setBatch(e.target.value);
                      }}
                      onKeyPress={handleKeyPress}
                      value={batch}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Reference PO Number</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      // onChange={(e) => {
                      //   setCustomerName(e.target.value);
                      // }}
                      // onKeyPress={handleKeyPress}
                      // value={customerName}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Desc</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      value={selectMaterial.materialDescription}
                      disabled
                    />
                  </Col>
                  <Col sm={1}>
                    <Button variant="light" onClick={handleShowMaterial}>
                      <i className="fa fa-search"></i>
                    </Button>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Code</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      value={selectMaterial.materialCode}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Button className="btn btn-primary" onClick={handleSearch}>
                    Search
                  </Button>
                </Col>
              </Form.Group>
            </Form.Group>
          </Form>

          {/* Table */}
          {data.length > 0 && (
            <div className="table-container">
              <WithoutRtvTable
                data={data}
                page={pageNo}
                sizePerPage={pageSize}
                totalSize={totalRecord}
                onTableChange={handleTableChange}
                loading={loading}
              />
            </div>
          )}
        </CardBody>
      </Card>

      {/* customer */}

      <Modal show={show} onHide={handleClose} size="lg">
        <LoadingFetchData active={overlayCustomer} />
        <Modal.Header closeButton>
          <Modal.Title>Customer Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      onChange={(e) => {
                        setCustomerCode(e.target.value);
                      }}
                      value={customerCode}
                      required
                      type="number"
                      placeholder="Costumer Code"
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      onChange={(e) => {
                        setCustomerName(e.target.value);
                      }}
                      value={customerName}
                      required
                      type="text"
                      placeholder="Costumer Name"
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>

            <Button
              className="mb-5"
              variant="secondary"
              onClick={handleSearchCustomer}
            >
              Search
            </Button>
          </Form>
          {dataCustomer.length > 0 && (
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              keyField="customerId"
              data={tableDataCustomer}
              columns={columnsCustomer}
              pagination={paginationFactory()}
              // onTableChange={handleTableChangeCustomer}
              rowEvents={rowEventsCustomer}
              hover
            />
          )}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {/* customer */}

      <Modal show={showMaterial} onHide={handleCloseMaterial} size="lg">
        <LoadingFetchData active={overlayStateMaterial} />
        <Modal.Header closeButton>
          <Modal.Title>Material Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      onChange={(e) => {
                        setMaterialCode(e.target.value);
                      }}
                      value={materialCode}
                      required
                      type="text"
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      onChange={(e) => {
                        setMaterialName(e.target.value);
                      }}
                      value={materialName}
                      required
                      type="text"
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>

            <Button
              className="mb-5"
              variant="secondary"
              onClick={handleSearchMaterial}
            >
              Search
            </Button>
          </Form>
          {dataMaterial.length > 0 && (
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              keyField="customerId"
              data={tableDataMaterial}
              columns={columnsMaterial}
              pagination={paginationFactory()}
              // onTableChange={handleTableChangeCustomer}
              rowEvents={rowEventsMaterial}
              hover
            />
          )}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {/* Modal synch customer */}
      <Modal
        show={showCustomer}
        onHide={handleCloseCustomer}
        dialogClassName="modal-synch"
      >
        <Modal.Header closeButton>
          <Modal.Title>{}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Customer Code <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setCustomerCodeSynch(e.target.value);
                      }}
                      value={customerCodeSynch}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="number"
                      onChange={(e) => {
                        setCustomerNameSynch(e.target.value);
                      }}
                      value={customerNameSynch}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCustomer}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSynchCustomer}>
            Synch
          </Button>
        </Modal.Footer>{" "}
      </Modal>

      {/* Modal synch material */}
      <Modal
        show={showMaterialSynch}
        onHide={handleCloseMaterialSynch}
        dialogClassName="modal-synch"
      >
        <Modal.Header closeButton>
          <Modal.Title>Material</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Material <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setMaterialSynch(e.target.value);
                      }}
                      value={materialSynch}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Dist Channel</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setDistChannelSynch(e.target.value);
                      }}
                      value={distChannelSynch}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMaterialSynch}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSynchMaterial}>
            Sync
          </Button>
        </Modal.Footer>{" "}
      </Modal>

      {/* Modal synch materialExt */}
      <Modal
        show={showMaterialExt}
        onHide={handleCloseMaterialExt}
        dialogClassName="modal-synch"
      >
        <Modal.Header closeButton>
          <Modal.Title>Material Ext</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Table Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setTableName(e.target.value);
                      }}
                      value={tableName}
                      placeholder="KOTG619"
                    />
                  </Col>
                </Form.Group> */}
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Sales Org <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setSalesOrg(e.target.value);
                      }}
                      value={salesOrg}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Material <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setMaterialSynch(e.target.value);
                      }}
                      value={materialSynch}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setCustomerCode(e.target.value);
                      }}
                      value={customerCode}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Batch</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setBatch(e.target.value);
                      }}
                      value={batch}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Plant</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setPlant(e.target.value);
                      }}
                      value={plant}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>IC4</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setIc4(e.target.value);
                      }}
                      value={ic4}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>DocCat</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setDocCat(e.target.value);
                      }}
                      value={docCat}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>CG1</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setCg1(e.target.value);
                      }}
                      value={cg1}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMaterialExt}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSynchMaterialExt}>
            Sync
          </Button>
        </Modal.Footer>{" "}
      </Modal>
    </>
  );
};
